import React, { Fragment, Component } from 'react'
import {
    Paper,
    Typography,
    Button,
    Divider,
} from '@material-ui/core';

const classes = {
    card: {
        width: '640px',
        padding: '2rem 3rem 2rem',
    },
    cardWithFooter: {
        width: '640px',
        padding: '2rem 3rem 1.5rem',
    },
    cardFooter: {
        width: '640px',
        padding: '2rem 3rem',
        borderTop: '1px solid rgba(0, 0, 0, 0.12)',
    },
    label: {
        color: '#3c4043',
    },
    paddingLeft: {
        paddingLeft: '1rem',
    },
    marginBottom: {
        margin: '1.5rem 0',
        paddingLeft: '1rem',
    },
}

const Page = (props) => {
    const { title, footerContent, children } = props;

    const PageBody = (
        <Fragment>
            <Typography style={{ textAlign: 'center', marginTop: '.8rem', marginBottom: '.8rem' }} variant="h5">
                {title}
            </Typography>
            <div style={{ padding: '0 1.4rem 0' }}>
                {children}
            </div>
        </Fragment>
    );

    return (
        <Fragment>
            {footerContent ? (
                <Paper elevation={1}>
                    <div style={classes.cardWithFooter}>
                        {PageBody}
                    </div>
                    <div style={classes.cardFooter}>
                        {footerContent}
                    </div>
                </Paper>
            ) : (
                <Paper elevation = { 1 } style = {classes.card}>
                    {PageBody}
                </Paper>
            )}
        </Fragment>
    );
};

class AccountComponent extends Component {

    makeFields = data => (
        data.map(({ label, value }, i) => (
            <div key={i} style={classes.marginBottom}>
                { value && (
                    <Fragment>
                        <Typography style={classes.label} variant="caption">{label}</Typography>
                        <Typography variant="body1">{value}</Typography>
                    </Fragment>
                )}
            </div>
        ))
    )

    makeColumns = data => (
        data.map((obj, i) => (
            <div key={i + 'cc'} className="col-5 offset-1">
                { this.makeFields(obj) }
            </div>
        ))
    )

    render() {
        const { user, logout } = this.props;

        const { email, firstname, lastname, organization } = user;
        const { jobTitle, orgType, phone, website, city, state, } = user.data;

        const firstSection = [
            [
                {
                    label: 'Name',
                    value: `${firstname} ${lastname}`,
                },
                {
                    label: 'E-mail',
                    value: email,
                },
            ],
            [
                {
                    label: 'Job Title',
                    value: jobTitle,
                },
            ],
        ];

        const secondSection = [
            [
                {
                    label: 'Organization Type',
                    value: orgType,
                },
                {
                    label: 'Phone Number',
                    value: phone,
                },
            ],
            [
                {
                    label: 'Organization',
                    value: organization,
                },
                {
                    label: 'Website',
                    value: website,
                },
            ],
        ];

        const thirdSection = [
            [
                {
                    label: 'City',
                    value: city,
                },
            ],
            [
                {
                    label: 'State',
                    value: state,
                },
            ],
        ];

        return (
            <div className="body-center">
                <Page
                    title="Account Details"
                    footerContent={(
                        <div className="d-flex justify-content-center">
                            <Button
                                variant="outlined"
                                onClick={() => { logout() }}
                            >
                                Logout
                            </Button>
                        </div>
                    )}
                >
                    <div className="row row-spacing">
                        {this.makeColumns(firstSection)}
                    </div>
                    <Divider variant="middle" />
                    <div className="row row-spacing">
                        {this.makeColumns(secondSection)}
                    </div>
                    <Divider variant="middle" />
                    <div className="row row-spacing">
                        {this.makeColumns(thirdSection)}
                    </div>
                </Page>
            </div>
        )
    }
}

export default AccountComponent